const pt = {
  common: {
    home: "Home",
    shop: "Loja",
    myOrders: "Compras",
    cart: "Carrinho",
    logout: "Sair",
    loading: "Carregando...",
    all: "Todos",
    you: "Você",
    price: "Preço",
    subtotal: "Subtotal",
    discount: "Desconto",
    total: "Total",
    action: "Ação",
    photos: "Fotos",
    fullscreen: "Tela cheia",
    clickToExpand: "Clique para ampliar",
    backToTop: "Voltar ao topo",
    back: "Voltar",
    support: "Suporte",
    error: "Erro",
  },
  home: {
    title: "Welcome to my",
    marketplace: "Marketplace",
    subtitle: "Um lugar criado especialmente para você colecionar suas melhores lembranças no vôlei.",
    goToShop: "Ir para a loja",
  },
  shop: {
    greeting: "Olá, {name}",
    defaultAthleteName: "Atleta",
    photoGallery: "Galeria de Fotos",
    upToDiscount: "Até {percent}% off",
    discountApplied: "Desc.: {percent}%",
    searchLabel: "Pesquisa por atleta, tags ou local",
    searchPlaceholder: "Ex.: nome do atleta, seleção, final etc.",
    clearSearch: "Limpar pesquisa",
    noPhotosFound: "Fotos não localizadas",
    discountTag: "Desc",
    wantPhoto: "Quero",
    wantThisPhoto: "Quero esta foto",
    removeFromCart: "Remover do carrinho",
    buyPhotos: "Comprar fotos",
    fitMode: "⊡ Ajustar",
    panoramicMode: "↔ Panorâmica",
    photoCounter: "{current} de {total}",
  },
  cart: {
    title: "Seu carrinho",
    emptyMessage: "Seu carrinho está vazio.",
    goToShop: "Ir para a loja",
    clearCart: "Limpar carrinho",
    minPhotosWarning: "Selecione no mínimo {min} foto{plural} para prosseguir com a compra.",
    proceedToPayment: "Finalizar compra",
    photosHeader: "Fotos",
    valueHeader: "Valor",
    actionHeader: "Ação",
    removeBtn: "Remover",
    cartFloating: "Carrinho",
  },
  payment: {
    infoTitle: "Informações",
    totalPhotos: "Total de fotos:",
    purchasedAt: "Compra realizada em:",
    subtotal: "Subtotal",
    discount: "Desconto",
    total: "Total",
    pixCopyPaste: "Pix copia e cola",
    copyPixKey: "Copiar chave pix",
    generateAgain: "Gerar novamente",
    status: "Status:",
    statusPending: "Pendente",
    statusInReview: "Pagamento em análise",
    statusPaid: "Pago",
    instructionsTitle: "Instruções:",
    instruction1: "1. Acesse o app do seu banco e vá até a área do PIX",
    instruction2: "2. Procure por PIX COPIA E COLA",
    instruction3: "3. Cole o código, confira os dados e finalize o pagamento.",
    customPaymentNote: "",
    itemsPurchasedTitle: "Itens Comprados",
    downloadBtn: "Download",
    loadingItems: "Carregando itens comprados...",
    reloadHint: "Caso demore muito, atualize a página.",
    copiedSuccess: "Chave Pix copiada para área de transferência",
    copyFail: "Não foi possível copiar automaticamente",
    generatingPix: "Gerando chave pix...",
  },
  orders: {
    title: "Minhas compras",
    noOrders: "Você ainda não fez compras.",
    errorLoading: "Erro ao buscar compras.",
    dateTime: "Data/Hora",
    quantity: "Qtd",
    value: "Valor",
    status: "Status",
    details: "Detalhes",
  },
  phoneModal: {
    title: "Receba atualização pelo WhatsApp",
    approvalNotice: "⏱️ Aprovação em até 4 horas",
    approvalDescription: "A aprovação do pagamento pode levar até 4 horas. Cadastre seu WhatsApp para receber notificação na hora",
    phonePlaceholder: "Digite seu número",
    save: "Salvar e Continuar",
    saving: "Salvando...",
    later: "Agora não",
  },
  auth: {
    welcome: "Bem-vindo(a), {name}!",
    storeAccess: "Acesso à Loja",
    restrictedAreaAlert: "Esta área é restrita a atletas e assessorias.",
    accessCode: "Código de acesso",
    enter: "Entrar",
    noCodeWhatsapp: "Ainda não tem código? Só me chamar no Whatsapp:",
    whatsappMessage: "Oi, Adauto. Preciso de um código de acesso.",
    authenticating: "Autenticando acesso...",
  },
};

export default pt;